/**
 * Formulaire de recherche Keycloak (sans recherche automatique).
 * Responsabilité: gérer uniquement le rendu du champ + bouton, et déléguer l'action au parent.
 */

import React from 'react'
import { useTranslation } from 'react-i18next'

export type KeycloakImportSearchType = 'UTILISATEUR' | 'COMPTE_SERVICE'

type Props = {
  value: string
  onChange: (next: string) => void
  searchType: KeycloakImportSearchType
  onSearchTypeChange: (next: KeycloakImportSearchType) => void
  onSearch: () => void
  disabled: boolean
  isLoading: boolean
}

export const KeycloakImportSearchForm: React.FC<Props> = ({
  value,
  onChange,
  searchType,
  onSearchTypeChange,
  onSearch,
  disabled,
  isLoading,
}) => {
  const { t } = useTranslation()

  return (
    <div className="flex items-center gap-3">
      <input
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={t('profiles.importKeycloak.searchPlaceholder')}
        className="border border-gray-300 p-2 rounded-[5px] h-[50px] text-xl w-[400px]"
      />
      <select
        value={searchType}
        onChange={(e) =>
          onSearchTypeChange(e.target.value as KeycloakImportSearchType)
        }
        aria-label={t('profiles.importKeycloak.searchTypeLabel')}
        className="border border-gray-300 p-2 rounded-[5px] h-[50px] text-base"
      >
        <option value="UTILISATEUR">{t('profiles.importKeycloak.user')}</option>
        <option value="COMPTE_SERVICE">
          {t('profiles.importKeycloak.serviceAccount')}
        </option>
      </select>
      <button
        onClick={onSearch}
        className="btn default shrink-0"
        disabled={disabled}
      >
        {t('profiles.importKeycloak.searchButton')}
        {isLoading && <span className="button-loader ml-2 align-middle"></span>}
      </button>
    </div>
  )
}
